import { render, staticRenderFns } from "./PopupEditer.vue?vue&type=template&id=706b9fca&scoped=true&"
import script from "./PopupEditer.vue?vue&type=script&lang=js&"
export * from "./PopupEditer.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditer.vue?vue&type=style&index=0&id=706b9fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b9fca",
  null
  
)

export default component.exports